import user from "../../../enums/user";

/*=========================================================================================
  File Name: moduleMailSendResumeMutations.js
  Description: Kinds Module Mutations
  ----------------------------------------------------------------------------------------
==========================================================================================*/
export default {
  SET_MAIL_SEND_RESUMES (state, mailSendResumes) {
    state.mailSendResumes = mailSendResumes
  },
  SET_INFO_DB(state, payload){
    state.infoDB = payload
  },
}